import React from 'react';
import { bool, func, oneOfType, string, number } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { LoyaltyContainer, LoyaltyText, TransparentButton } from './loyalty.styles';

const Loyalty = ({
  value,
  color,
  icon,
  textColor,
  onClick,
  hasInfo
}) => {
  return /*#__PURE__*/React.createElement(LoyaltyContainer, {
    color: color,
    "data-testid": "loyalty",
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
    }
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    "data-testid": `${icon}Icon`,
    name: icon,
    width: "12px",
    height: "12px",
    color: "#fff"
  }), /*#__PURE__*/React.createElement(LoyaltyText, {
    color: textColor,
    "data-testid": "loyalty-value"
  }, currencyFormatter({
    value: parseFloat(value)
  })), hasInfo && /*#__PURE__*/React.createElement(TransparentButton, {
    "data-testid": "loyalty-info-button",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "HelpOutline",
    color: "none",
    width: "12px",
    height: "12px"
  })));
};

Loyalty.defaultProps = {
  hasInfo: false,
  color: undefined
};
process.env.NODE_ENV !== "production" ? Loyalty.propTypes = {
  value: oneOfType([string, number]).isRequired,
  color: string,
  icon: string,
  textColor: string,
  onClick: func,
  hasInfo: bool
} : void 0;
export default Loyalty;